import { Component, Input, OnInit } from '@angular/core';
import { LabelService } from 'src/app/labels/label.service';
import { ELabelType, ILabel } from 'src/app/models/label';
import { AbstractControl } from '@angular/forms';

@Component({
    selector: 'app-label-selector-area',
    templateUrl: './label-selector-area.component.html',
    styleUrls: ['./label-selector-area.component.scss'],
})
export class LabelSelectorAreaComponent implements OnInit {
    @Input() labelControl: AbstractControl;
    @Input() labelType: ELabelType;
    @Input() entityId: string | number;

    labels: ILabel[] = [];
    loaded = false;
    constructor(private labelService: LabelService) {}

    ngOnInit(): void {
        this.labelService.findAllLabels(this.labelType).subscribe((labels) => {
            const selectedlableIds = this.labelControl.value.ids;
            this.labels = labels.filter((l) => selectedlableIds?.includes(l.id));
            this.loaded = true;
        });
    }

    labelsSelected(values) {
        if (!this.loaded) return;
        const selectedlabels = values.labels;
        const entityId = values.entityId;
        this.labelControl.setValue({
            relatedEntityId: entityId,
            ids: selectedlabels.map((l) => l.id),
        });
    }
}
